import React from 'react'
import Header from './components/Header'
import Footer from './components/Footer'

// import { Navigate, Outlet, useLocation, useNavigate } from "react-router-dom"

function Main({ children }) {
  return (
    <div className='min-h-screen flex flex-col'>
      <div  className='flex-grow'>
        <Header />
        {/* <Outlet /> */}
        {children}
      </div>
      <Footer />
    </div>
  )
}

export default Main
